import { AxiosInstance } from 'axios'

interface AppointmenData {
  appointmentWindowId: string;
  startDateTime: string;
  appointmentWindowName: string;
  available: string;
  endDateTime: string;
}
export interface ResponseProps {
  appointmentWindowData: AppointmenData[] | null;
}
export interface AppointmentProps {
  data: AppointmenData[] | null;
  message: string;
}
export default function Appointments(client: AxiosInstance) {
  async function getAppointments() {
    try {
      // Get token from sessionStorage
      const token = sessionStorage && sessionStorage.getItem('access_token')
      
      if (!token) {
        return {
          data: null,
          message: 'No authentication token available',
        }
      }

      // Call server-side appointments endpoint with token
      const { data } = await client.post<AppointmentProps>('appointments', { token })
      
      return {
        data: data?.data,
        message: data?.message || 'success',
      }
    } catch (err: any) {
      return {
        data: null,
        message: err.response?.data?.message || err.message || 'Failed to get appointments',
      }
    }
  }

  return {
    getAppointments,
  }
}
